(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TicketOrderDetailDialogController', TicketOrderDetailDialogController);

    TicketOrderDetailDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'selectedTicket'];

    function TicketOrderDetailDialogController ($timeout, $scope, $uibModalInstance, selectedTicket) {
        var vm = this;

        vm.selectedTicket = selectedTicket;
        vm.close = close;
        vm.passengersCollapsed = false;
        vm.segmentGroups = { outgoing: [], return: [], other: [] };
        vm.hhmm = hhmm;
        vm.durationLabel = durationLabel;
        vm.togglePassengers = togglePassengers;

        buildSegmentGroups();

        function close() {
            $uibModalInstance.dismiss('cancel');
        }

        function buildSegmentGroups() {
            vm.segmentGroups = { outgoing: [], return: [], other: [] };

            var segs = (vm.selectedTicket && vm.selectedTicket.segments) ? vm.selectedTicket.segments : [];
            segs.forEach(function (s) {
                if (s && s.direction === 0) vm.segmentGroups.outgoing.push(s);
                else if (s && s.direction === 1) vm.segmentGroups.return.push(s);
                else vm.segmentGroups.other.push(s);
            });
        }

        function hhmm(timeStr) {
            if (!timeStr) return '';
            var p = timeStr.split(':');
            return p[0] + ':' + p[1];
        }

        function durationLabel(duration) {
            if (!duration || !duration.flight) return '';
            var total = duration.flight.common;
            var h = Math.floor(total / 60);
            var m = total % 60;
            return h + ' hours ' + m + ' min';
        }

        function togglePassengers() {
            vm.passengersCollapsed = !vm.passengersCollapsed;
        }
    }
})();
